// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3XbQV","notes":"Notes_notes__1JZ9O","note":"Notes_note__n-EWy","markdown":"Notes_markdown__16eDP"};